import { Link } from 'react-router-dom';

const CONTACT_EMAIL = 'seawars@pi24.pl';

/**
 * Polityka prywatności i regulamin — jedna strona, po polsku, per `docs/06` §6.5.
 *
 * Opisuje to, co aplikacja faktycznie robi dziś, nie docelowy stan z dokumentacji:
 * rejestracja jest otwarta, ale wyłącznie przez link zaproszenia od innego użytkownika
 * (`docs/08-decyzje.md` #9/#18, zaktualizowane); usuwanie i eksport WŁASNYCH danych
 * nadal załatwia się przez kontakt e-mail — panel admina (`admin/users.ts`) pozwala
 * to zrobić administratorowi, ale nie jest samoobsługowy dla samego użytkownika.
 */
export function PrivacyPage() {
  return (
    <>
      <div className="card game__header">
        <h2 className="hand">Polityka prywatności i regulamin</h2>
        <Link to="/" className="btn btn--ghost">
          Wróć do lobby
        </Link>
      </div>

      <article className="card legal">
        <p className="app__note">Ostatnia aktualizacja: wrzesień 2026.</p>

        <h3 className="hand">Kim jesteśmy</h3>
        <p>
          Statki (sea-wars) to hobbystyczna gra w statki dla dwóch graczy, prowadzona jako projekt
          jednoosobowy. W sprawach danych osobowych i regulaminu pisz na{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>

        <h3 className="hand">Jakie dane przetwarzamy</h3>
        <ul>
          <li>nick i opcjonalny adres e-mail podane przy założeniu konta,</li>
          <li>hash hasła (argon2id) — samo hasło nigdy nie jest zapisywane,</li>
          <li>
            przy rejestracji z linku zaproszenia — kto Cię zaprosił (jedno konto, bez dalszej
            historii udostępniania linku),
          </li>
          <li>przebieg rozegranych partii: ruchy, wynik, czas trwania,</li>
          <li>
            adres IP wyłącznie jako nieodwracalny skrót (HMAC), do ograniczenia prób logowania —
            nigdy w postaci jawnej,
          </li>
          <li>
            podstawowe zdarzenia produktowe (np. rozpoczęcie partii, rozłączenie) bez treści
            osobistych, używane do prostych statystyk działania usługi.
          </li>
        </ul>
        <p>Nic ponad to: bez fingerprintingu, bez trackerów reklamowych, bez sprzedaży danych.</p>

        <h3 className="hand">Ciasteczka</h3>
        <p>
          Jedyne ciasteczko to sesja logowania (funkcjonalne, niezbędne do działania gry). Analityka
          nie używa ciasteczek ani identyfikatorów międzysesyjnych, więc baner zgody nie jest tu
          potrzebny.
        </p>

        <h3 className="hand">Podstawa prawna i odbiorcy danych</h3>
        <p>
          Przetwarzamy dane w celu świadczenia usługi (wykonanie umowy o korzystanie z gry) oraz na
          podstawie uzasadnionego interesu (bezpieczeństwo konta, historia rozgrywek widoczna dla
          obu graczy danej partii). Dane trafiają wyłącznie do dostawców niezbędnych do działania
          usługi — hostingu serwera i bazy danych oraz narzędzia do monitorowania błędów aplikacji —
          nigdy w celach marketingowych ani do dalszej odsprzedaży.
        </p>

        <h3 className="hand">Retencja</h3>
        <p>
          Konto i historia partii są przechowywane do usunięcia konta. Skróty adresów IP zachowujemy
          30 dni, wyłącznie do celów bezpieczeństwa logowania.
        </p>

        <h3 className="hand">Twoje prawa</h3>
        <p>
          Masz prawo do wglądu w swoje dane, ich sprostowania, usunięcia oraz przeniesienia. Nie ma
          jeszcze samoobsługowego panelu konta — napisz na{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>, a odpowiemy i wykonamy żądanie
          najszybciej, jak się da.
        </p>

        <h3 className="hand">Regulamin</h3>
        <ul>
          <li>
            Rejestracja jest możliwa wyłącznie przez link zaproszenia od innego użytkownika — nie ma
            otwartego, publicznego zapisu.
          </li>
          <li>Nie gwarantujemy nieprzerwanej dostępności ani zachowania danych bez awarii.</li>
          <li>Danych logowania nie wolno udostępniać osobom trzecim.</li>
          <li>
            Zabronione są działania zakłócające działanie usługi lub naruszające prawa innych
            graczy.
          </li>
          <li>
            Ten dokument może się zmieniać w miarę rozwoju projektu — istotne zmiany ogłosimy w
            aplikacji.
          </li>
        </ul>
      </article>
    </>
  );
}
